import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LoginForm } from "@/components/auth/LoginForm";
import { AuthCard } from "@/components/auth/AuthCard";

const Login = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-secondary/50">
      <Button
        variant="ghost"
        onClick={() => navigate("/")}
        className="absolute top-4 left-4"
      >
        ← Back to Home
      </Button>
      
      <AuthCard
        title="Dashboard"
        description="Sign in to access your queues"
      >
        <LoginForm />
      </AuthCard>
    </div>
  );
};

export default Login;